@for (file of getFilesById(); track $index) {
  <app-file-card
    [fileCard]="{
      id: file.id,
      fileParams: file.file,
      fileType: unitEconomicsCalculationsFileType,
      isEditModeActive: isEditModeActive(),
      shouldCheckImageType: false
    }"
    (handleDelete)="handleDelete($event, file)"
  />
}
<app-file-upload-card
  [fileUploadParams]="{
    parentId: unitEconomicsCalculationId(),
    recordId: unitEconomicsCalculationId(),
    type: `${unitEconomicsCalculationsFileType}-${unitEconomicsCalculationId()}`,
    entityFileType: unitEconomicsCalculationsFileType
  }"
  [isEditModeActive]="isEditModeActive()"
  (attachFile)="attachFile($event)"
/>
